module.exports = "/_next/static/images/piggy-6ac60c44c109ab5f32108957cdcf5399.svg";